import React from "react";
import './Avatar.css';

export const Avatar = ( props ) => {
    let {
        // size,
        // shape,
        // status,
        // className,
        src,

        //  bgcolor, 
        //  children, 
        //  attributes,
        //  cancel 
      } = props;

      return (
        <>
        <img
            alt="..."
            className="alumni-avatar"
            src={src}
        />
        
        </>
    );
  }